import OwnProfileLoader from './OwnProfileLoader';
import CalendarLoader from './CalendarLoader';
import MatchLoader from './MatchLoader';
import ChatsLoader from './ChatsLoader';
import CalendarSharesLoader from './CalendarSharesLoader';
import TestsLoader from './TestsLoader';
import TestsListener from './TestsListener';
import OtherUsersTestsLoader from './OtherUsersTestsLoader';

function Loaders() {
  return (
    <>
      <OwnProfileLoader />
      <CalendarLoader />
      <MatchLoader />
      <ChatsLoader />
      <CalendarSharesLoader />
      <TestsLoader />
      <TestsListener />
      <OtherUsersTestsLoader />
    </>
  );
}

export default Loaders;
